<template>
  <div :class="[{'no-options':noOptions}]" class="searchable-select">
    <div
      class="input"
      @keypress="keypress"
      @mousedown="setFocus"
      :class="{'active':showOptions,'error':error&&!showOptions}"
    >
      <img :src="image" alt />
      <div>
        <div v-if="label">{{label}}</div>
        <div v-show="!search" class="selected">{{stationMap[value]}}</div>
        <input
          type="text"
          v-bind="$attrs"
          v-model="search"
          @blur="inputBlur"
          @focus="showOptions=true"
        />
      </div>
    </div>
    <div v-show="showOptions" class="dropdown-panel">
      <template v-for="(optGroup,key) in stationList">
        <div class="opt-group" :key="key">{{countryMap[key]}}</div>
        <div
          class="option"
          :class="{'pre-select':option.code===preSelect,current:option.code===value}"
          v-for="option in optGroup"
          @mousedown="emitValue(option.code)"
          :key="option.code"
        >{{option.displayName}}</div>
      </template>
      <div class="prompt" v-show="!found">no result matched "{{search}}"</div>
    </div>
  </div>
</template>
<script>
import validatable from "../validatable";
export default {
  inheritAttrs: false,
  mixins: [validatable],
  name: "station-dropdown",
  props: {
    value: String,
    label: String,
    image: String,
    options: Object,
    countryMap: Object
  },
  data() {
    return {
      search: "",
      found: true,
      preSelect: "",
      stationList: {},
      showOptions: false
    };
  },
  created() {
    this.stationList = this.attachDisplayName(this.options);
  },
  watch: {
    showOptions: function(val) {
      if (val === false) {
        this.search = "";
      }
    },
    options: function(val) {
      this.stationList = this.attachDisplayName(val);
    },
    search(val) {
      if (!this.showOptions) {
        this.showOptions = true;
      }
      let result = {};
      let search = val ? new RegExp(val, "i") : null;
      let found = false;
      if (search) {
        Object.keys(this.options).forEach(k => {
          let stations = this.options[k].filter(
            x => x.displayName.search(search) !== -1
          );
          if (stations.length > 0) {
            found = true;
            result[k] = stations;
          }
        });
      } else {
        found = true;
        result = this.options;
        this.showOptions = false;
      }
      if (this.found != found) {
        this.found = found;
      }
      let countries = Object.keys(result);
      if (countries.length > 0) {
        this.preSelect = result[countries[0]][0].code;
      } else {
        this.preSelect = "";
      }
      this.stationList = result;
    }
  },
  computed: {
    noOptions() {
      return Object.keys(this.options).length === 0;
    },
    stationMap() {
      let dic = {};
      Object.entries(this.options).forEach(x =>
        x[1].forEach(y => (dic[y.code] = y.displayName))
      );
      return dic;
    }
  },
  methods: {
    keypress(e) {
      let key = e.key || e.code;
      let code = e.keyCode || e.which;

      if (
        code === 13 ||
        key === "Enter" ||
        code === 27 ||
        key === "Escape" ||
        code === 9 ||
        key === "Tab"
      ) {
        e.target.blur();
      }
    },
    setFocus(e) {
      e.preventDefault();
      this.showOptions = !this.showOptions;
      e.currentTarget.querySelector("input").focus();
      return false;
    },
    inputBlur() {
      if (this.showOptions) {
        this.showOptions = false;
      }
      if (this.preSelect) {
        this.emitValue(this.preSelect);
      }
    },
    emitValue(val) {
      this.preSelect = "";
      this.$emit("input", val);
    },
    attachDisplayName(options) {
      for (let country in options) {
        options[country].forEach(
          (x, i) =>
            (options[country][i].displayName = x.isMac
              ? x.name
              : `${x.name}(${x.code})`)
        );
      }
      return options;
    }
  }
};
</script>